(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steady-pdp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.steady-pdp').forEach(function(root){
  var main = root.querySelector('.sp-gallery-main img');
  root.querySelectorAll('.sp-thumb').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(!main) return;
      main.src = btn.getAttribute('data-full');
      root.querySelectorAll('.sp-thumb').forEach(function(t){t.classList.remove('is-active');});
      btn.classList.add('is-active');
    });
  });
  var atcs = root.querySelectorAll('.sp-atc');
  function setUrl(url){ if(!url) return; atcs.forEach(function(a){ a.setAttribute('href', url); }); }
  root.querySelectorAll('.sp-tier').forEach(function(tier){
    var input = tier.querySelector('input');
    tier.addEventListener('click', function(){
      if(input) input.checked = true;
      setUrl(tier.getAttribute('data-url'));
    });
    if(input && input.checked) setUrl(tier.getAttribute('data-url'));
  });
  var chart = root.querySelector('.sp-chart');
  if(chart){
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ chart.classList.add('in-view'); io.disconnect(); } });
      }, {threshold:0.35});
      io.observe(chart);
    } else { chart.classList.add('in-view'); }
  }
});

  } catch(e) { console.error(e); }
})();
})();
